export interface NavItem { label: string; path: string; }

/** The five doors' paths. Anything keyed by door (icons, say) is keyed by this,
 *  so a sixth door cannot be added without its icon. */
export type DoorPath = '/home' | '/sales' | '/payments' | '/costs' | '/settings';
export interface DoorItem extends NavItem { path: DoorPath; }

export const DOORS: DoorItem[] = [
  { label: 'Today', path: '/home' },
  { label: 'Sales', path: '/sales' },
  { label: 'Payments', path: '/payments' },
  { label: 'Costs', path: '/costs' },
  { label: 'Settings', path: '/settings' },
];

export const SALES_TABS: NavItem[] = [
  { label: 'Overview', path: '/sales/overview' },
  { label: 'Products', path: '/sales/products' },
  { label: 'Insights', path: '/sales/insights' },
  { label: 'Time', path: '/sales/time' },
  { label: 'Financials', path: '/sales/financials' },
  { label: 'History', path: '/sales/history' },
  { label: 'Weather', path: '/sales/weather' },
];

export const SETTINGS_TABS: NavItem[] = [
  { label: 'Account', path: '/settings/account' },
  { label: 'Data', path: '/settings/data' },
  { label: 'Connections', path: '/settings/connections' },
];

/** Is this door lit? Today (/home) only on itself; every other door on its
 *  own path and every room behind it — whole segments only, so a path that
 *  merely starts with the same letters (/salesforce) never lights Sales. */
export function doorIsOpen(doorPath: string, pathname: string): boolean {
  if (doorPath === '/home') return pathname === '/home';
  return pathname === doorPath || pathname.startsWith(`${doorPath}/`);
}

/** Old URLs keep working (emails, bookmarks, Square/Stripe returns) — query strings are kept. */
export const LEGACY_REDIRECTS: Record<string, string> = {
  '/dashboard': '/sales/overview',
  '/products': '/sales/products',
  '/insights': '/sales/insights',
  '/time-analysis': '/sales/time',
  '/financials': '/sales/financials',
  '/history': '/sales/history',
  '/upload': '/settings/data',
  '/integrations': '/settings/connections',
};
